import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';

import { Obituary } from 'types/services/obituary';
export interface Props {
  singleObituary: Obituary;
}
export const SingleObituary = (props: Props, idx?: string) => {
  const [formattedString, setFormattedString] = useState('');
  const [formattedStringBereaved, setFormattedStringBereaved] = useState('');

  let link = '/smrtovnica/';
  // ukoliko bude trebalo dodati imena sa smrtovnice u url kao sto je radjeno prije, iskoristiti sljedecu petlju i dodati / na kraj
  // props.singleObituary.people_id.forEach((p, i) => {
  //   link += p.firstName + '-' + p.lastName;
  //   if (i !== props.singleObituary.people_id.length - 1) link += '-';
  // });
  link += props.singleObituary?.id;

  useEffect(() => {
    if (props.singleObituary?.main_text) {
      const regex = /(<([^>]+)>)/gi;
      if (props.singleObituary && props.singleObituary?.main_text.match(regex)) {
        setFormattedString(
          props.singleObituary?.main_text.replace(regex, ' ').replace(new RegExp('\r?\n', 'g'), '<br />'),
        );
      }
    }
    if (props.singleObituary?.bereaved) {
      const regex = /(<([^>]+)>)/gi;
      if (props.singleObituary && props.singleObituary?.bereaved.match(regex)) {
        setFormattedStringBereaved(
          props.singleObituary?.bereaved.replace(regex, ' ').replace(new RegExp('\r?\n', 'g'), '<br />'),
        );
      }
    }
  }, [props]);
  return (
    <div className="mobileSingle" key={idx}>
      <div className="outline-front">
        <div className="masonryList">
          <a href={link} style={{ color: 'black' }}>
            <div className="singleObituary">
              {props.singleObituary?.personal_message?.length && props.singleObituary?.personal_message !== '' ? (
                <>
                  <span className="innerElement introductory_text_style">{props.singleObituary?.personal_message}</span>
                  <br></br>
                </>
              ) : (
                <></>
              )}
              <span
                className="innerElement introductory_text_style"
                dangerouslySetInnerHTML={{
                  __html: props.singleObituary?.introductory_text?.replace(new RegExp('\r?\n', 'g'), '<br />') || '',
                }}
              >
                {/* {props.singleObituary?.introductory_text} */}
              </span>
              <br></br>
              {props.singleObituary?.people_id.length === 1 ? (
                <div>
                  <span className="innerElement obituaryImage">
                    {props.singleObituary.people_id[0].filename && (
                      <img
                        src={props.singleObituary.people_id[0].filename}
                        alt="1"
                        style={{ width: '87px', height: '120px' }}
                      ></img>
                    )}
                  </span>
                  <br></br>
                  <span className="innerElement fullName">
                    {props.singleObituary?.people_id[0].firstName}{' '}
                    {props.singleObituary?.people_id[0].additional_name
                      ? '(' + props.singleObituary?.people_id[0].additional_name + ')'
                      : ''}{' '}
                    {props.singleObituary?.people_id[0].lastName}
                    {props.singleObituary?.people_id[0].maiden_name
                      ? ', ROĐ. ' + props.singleObituary?.people_id[0].maiden_name
                      : ''}
                  </span>
                  {/* {props.singleObituary?.people_id[0].city && (
                    <span className="city">{props.singleObituary?.people_id[0].city}</span>
                  )} */}
                  <br></br>
                  <span className="innerElement obituaryDate">
                    {props.singleObituary?.people_id[0].birth_date
                      ? DateTime.fromISO(String(props.singleObituary?.people_id[0].birth_date)).toLocaleString(
                          DateTime.DATE_SHORT,
                        )
                      : props.singleObituary?.people_id[0].birth_approx}
                    {(props.singleObituary?.people_id[0].birth_date && props.singleObituary?.people_id[0].birth_end) ||
                    (props.singleObituary?.people_id[0].birth_approx &&
                      props.singleObituary?.people_id[0].birth_end_approx) ||
                    (props.singleObituary?.people_id[0].birth_date &&
                      props.singleObituary?.people_id[0].birth_end_approx) ||
                    (props.singleObituary?.people_id[0].birth_approx && props.singleObituary?.people_id[0].birth_end)
                      ? ' - '
                      : ''}
                    {props.singleObituary?.people_id[0].birth_end
                      ? DateTime.fromISO(String(props.singleObituary?.people_id[0].birth_end)).toLocaleString(
                          DateTime.DATE_SHORT,
                        )
                      : props.singleObituary?.people_id[0].birth_end_approx}
                  </span>
                </div>
              ) : props.singleObituary?.people_id !== undefined && props.singleObituary?.people_id.length > 1 ? (
                <div className="obituary-wrapper">
                  {props.singleObituary.people_id.map((p, i) => {
                    return (
                      <div className="obituary-child" key={props.singleObituary.id + i}>
                        <span className="innerElement">
                          {props.singleObituary.people_id[i].filename && (
                            <img
                              src={props.singleObituary.people_id[i].filename}
                              alt="/1.png"
                              style={{ width: '87px', height: '120px' }}
                            ></img>
                          )}
                        </span>
                        <br></br>
                        <span className="innerElement fullName">
                          {props.singleObituary?.people_id[i].firstName}{' '}
                          {props.singleObituary?.people_id[i].additional_name
                            ? '(' + props.singleObituary?.people_id[i].additional_name + ')'
                            : ''}{' '}
                          {props.singleObituary?.people_id[i].lastName}
                          {props.singleObituary?.people_id[i].maiden_name
                            ? ', ROĐ. ' + props.singleObituary?.people_id[i].maiden_name
                            : ''}
                        </span>
                        {/* {props.singleObituary?.people_id[i].city && (
                          <span className="city">{props.singleObituary?.people_id[i].city}</span>
                        )} */}

                        {props.singleObituary?.people_id[i].birth_date ||
                        props.singleObituary?.people_id[i].birth_approx ||
                        props.singleObituary?.people_id[i].birth_end_approx ||
                        props.singleObituary?.people_id[i].birth_end ? (
                          <br />
                        ) : (
                          <></>
                        )}

                        <span className="innerElement bottom-date obituaryDate">
                          {props.singleObituary?.people_id[i].birth_date
                            ? DateTime.fromISO(String(props.singleObituary?.people_id[i].birth_date)).toLocaleString(
                                DateTime.DATE_SHORT,
                              )
                            : props.singleObituary?.people_id[i].birth_approx}
                          {(props.singleObituary?.people_id[i].birth_date &&
                            props.singleObituary?.people_id[i].birth_end) ||
                          (props.singleObituary?.people_id[i].birth_approx &&
                            props.singleObituary?.people_id[i].birth_end_approx) ||
                          (props.singleObituary?.people_id[i].birth_date &&
                            props.singleObituary?.people_id[i].birth_end_approx) ||
                          (props.singleObituary?.people_id[i].birth_approx &&
                            props.singleObituary?.people_id[i].birth_end)
                            ? ' - '
                            : ''}
                          {props.singleObituary?.people_id[i].birth_end
                            ? DateTime.fromISO(String(props.singleObituary?.people_id[i].birth_end)).toLocaleString(
                                DateTime.DATE_SHORT,
                              )
                            : props.singleObituary?.people_id[i].birth_end_approx}
                        </span>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <></>
              )}
              <br></br>
              <span
                className="innerElement obituatyMainText"
                dangerouslySetInnerHTML={{
                  __html:
                    formattedString && formattedString !== ''
                      ? formattedString
                      : props.singleObituary?.main_text?.replace(new RegExp('\r?\n', 'g'), '<br />') || '',
                }}
              >
                {/* {formattedString && formattedString !== '' ? formattedString : props.singleObituary?.main_text} */}
              </span>
              {/* <span style={{ marginTop: '20px' }} className="innerElement obituaryBereaved">
                {props.singleObituary?.bereaved}
              </span> */}
              <span
                style={{ marginTop: '20px' }}
                className="innerElement obituatyMainText"
                dangerouslySetInnerHTML={{
                  __html:
                    formattedStringBereaved && formattedStringBereaved !== ''
                      ? formattedStringBereaved
                      : props.singleObituary?.bereaved?.replace(new RegExp('\r?\n', 'g'), '<br />') || '',
                }}
              >
                {/* {formattedString && formattedString !== '' ? formattedString : props.singleObituary?.main_text} */}
              </span>
              <span className="innerElement obiNum"></span>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};
